import { Platform, AsyncStorage } from 'react-native';
import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';
import { encode } from 'base-64';
import { Base64 } from 'js-base64';
import {
  RM_ACCESS,
  VASCO_STATUSES,
  VASCO_FLOW,
  API_RESPONSE_CODES,
  RM_ACCESS_ERROR_CODE,
  CHANNEL_TYPES,
  ROUTES,
  APIRESPONSECODES,
  DOCSIGN_API_ERROR_CODES,
  RM_LOGIN
} from '../constants';
import config from '../data/settings';
import call from '@dbk/ui-icons/src/call';
import lsome from 'lodash/some';
import { isEmpty } from 'lodash';
import Settings from '../data/settings';

const USER_MGMT_PATH = 'roster.data.usermgmt';

export default () => muster()

  .path('rmAccess.getSmartCardUrl', {
    call: async ({ req }, { get, set, call }) => {
      const guidStr = Guid();
      await set('rmAccess.showSpinner', true);
      const [result] = await getValues(get(`${USER_MGMT_PATH}.getSmartCardURL["${guidStr}"]`));
      isValidJsonString(result).then(async (data) => {
        if (data.smartCardServerUrl) {
          await set('rmAccess.smartCardUrl', data.smartCardServerUrl);
        }
      }).catch(async (error) => {
        await set('rmAccess.showSpinner', false)
      });
    }
  })

  .path('rmAccess.fetchUserIdDetails', {
    call: async ({ req }, { get, set, call }) => {
      const email = req.args[0];
      const ipAddress = req.args[1];
      const isRmUpdate = req.args[2];
      const moduleName = req.args[3];
      const isRMGroup = true;
      const guidStr = Guid();
      const inputParam = `${email}#@#${ipAddress}#@#${isRMGroup}#@#${isRmUpdate}#@#${moduleName}`;
      const [messages] = await getValues(get('i18n.messages'));
      const [result] = await getValues(get(`${USER_MGMT_PATH}.getUserIdDetails["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        if (data) {

          await set('auth.authHeader', data.jwt);
          await set('auth.userId', data.userId);
          await set('rmAccess.userAdminGroup', data.userAdminGroup);
          await set('rmAccess.oracleUserId', data.oracleUserId);
          await set('rmAccess.adminEmailId', data.email);

          // Check for ACL access rights not available error handling
          if (data.userAdminGroup !== RM_ACCESS.RM_READ_ONLY &&
            data.userAdminGroup !== RM_ACCESS.RM_DOC_UPLOAD) {
            await Promise.all([
              set('rmAccess.showSpinner', false),
              set('rmAccess.showErrorModal', true),
              set('rmAccess.errorMsg', messages['app.rmAccess.aclNotMet']),
            ])
            return;
          }

          // Check for Avaloq access rights - OracleUserId for RM Access
            if (!data.oracleUserId && !data.email) {
              await Promise.all([
                set('rmAccess.showSpinner', false),
                set('rmAccess.showErrorModal', true),
                set('rmAccess.errorMsg', messages['app.rmAccess.avaloqNotRegistered']),
              ])
              return;
            }

          if (data.SessionActive === RM_ACCESS.SESSION_ACTIVE) {
            await set('rmAccess.showSpinner', false);
            await set('auth.userId', data.userId);
            await set('rmAccess.confirmationPopup', true);
            return;
          }

          call('rmAccess.fetchRMEntitlements', data.userAdminGroup, data.userId);

        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.showSpinner', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError'])
        ])
      });
    }
  })

  .path('rmAccess.fetchRMEntitlements', {
    call: async ({ req }, { get, set, call }) => {
      const roleName = req.args[0];
      const userId = req.args[1];
      const guidStr = Guid();
      const inputParam = `${roleName}#@#${userId}`;
      const [messages] = await getValues(get('i18n.messages'));
      const [result] = await getValues(get(`roster.data.getEntitlementsforRM["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        await set('rmAccess.showSpinner', false);
        await set('rmAccess.loading', false);  // need this for confirmationpopup
        //  RM Read only access
        if (data && data.roles[0] === RM_ACCESS.RM_READ_ONLY) {
          await set('rmAccess.rmAuthorised', true);
          await call('ui.history.replace', { pathname: '/rm-access/search' });
          return;
        }
        // RM Doc Upload
        if (data && data.roles[0] === RM_ACCESS.RM_DOC_UPLOAD) {
          const [currentPath] = await getValues(get('ui.history.currentLocation.pathname'));
          if ((currentPath.includes(ROUTES.RMACCESS.DOC_LANDING_PAGE))) {
            await call('ui.history.replace', { pathname: ROUTES.RMACCESS.DOC_TAB_CONTAINER });
            return;
          }else if(currentPath.includes(ROUTES.RMACCESS.LOGIN_PAGE)){
            await call('ui.history.replace', { pathname: ROUTES.RMACCESS.DOC_LANDING_PAGE });
            return;
          }
        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.showSpinner', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError'])
        ])
      });
    }
  })

  .path('rmAccess.resetAllVariables', {
    call: async ({ req }, { set }) => {
      await Promise.all([
        set('auth.authHeader', null),
        set('auth.userId', null)
      ])
    }
  })

  /* WMCE-2889 /getcontracts API added to implement Search functionality by BP or CN */
  .path('rmAccess.getContractsList', {
    call: async ({ req }, { get, set, call }) => {
      await set('rmAccess.showContractList', false)
      await set('rmAccess.showSpinner', true)
      const guidStr = Guid();
      const [messages, adminUserId] = await getValues(get(['i18n.messages', 'auth.userId']));
      const bpId = req.args[0];
      const contractId = req.args[1];
      const inputParam = `${adminUserId}#@#${bpId}#@#${contractId}`;
      await call('rmAccess.resetSearchVariables');
      const [result] = await getValues(get(`roster.data.bankerrmaccess.getContractsList["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        if (data) {
          if (data.returnCode === RM_ACCESS.SEARCH_SUCCESS) {
            if (data.contractValue && data.contractValue.length !== 0) {
              await Promise.all([
                set('rmAccess.contractsData', data.contractValue),
                set('rmAccess.showSpinner', false),
                set('rmAccess.showContractList', true)
              ])
            }
            else {
              await Promise.all([
                set('rmAccess.showSpinner', false),
                set('rmAccess.showErrorModal', true),
                set('rmAccess.errorMsg', messages['app.rmAccess.search.error.msg']),
                set('rmAccess.errorTitle', messages['app.rmAccess.search.error.title']),

              ])
            }
          }
          else if (data.returnCode === RM_ACCESS.SEARCH_ERROR) {
            if (data.error && data.error.errorCode === RM_ACCESS.NO_ACCESS_BP) {
              await Promise.all([
                set('rmAccess.errorMsg', messages['app.rmAccess.search.error.msg.bp.contract']),
                set('rmAccess.errorTitle', messages['app.rmAccess.search.error.title']),
                set('rmAccess.showSpinner', false),
                set('rmAccess.showErrorModal', true)

              ])
            } else if (data.error && data.error.errorCode === RM_ACCESS.NO_ACCESS_CONTRACT_ID) {
              await Promise.all([
                set('rmAccess.errorMsg', messages['app.rmAccess.search.error.msg.bp.contract']),
                set('rmAccess.errorTitle', messages['app.rmAccess.search.error.title']),
                set('rmAccess.showSpinner', false),
                set('rmAccess.showErrorModal', true)

              ])
            } else {
              await Promise.all([
                set('rmAccess.errorMsg', messages['app.rmAccess.search.error.msg']),
                set('rmAccess.errorTitle', messages['app.rmAccess.search.error.title']),
                set('rmAccess.showSpinner', false),
                set('rmAccess.showErrorModal', true)

              ])
            }
          }
        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle']),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError']),
          set('rmAccess.showSpinner', false),
          set('rmAccess.showErrorModal', true)

        ])
      });
    }
  })

  .path('rmAccess.resetSearchVariables', {
    call: async ({ req }, { get, set, call }) => {
      await Promise.all([
        set('rmAccess.loading', false),
        set('rmAccess.showContractList', false),
        set('rmAccess.errorMsg', null),
        set('rmAccess.errorTitle', null),
        set('rmAccess.contractsData', null),
        set('rmAccess.selectedContract', null),
      ])
    }
  })

  .path('rmAccess.errorMsg', variable(null))
  .path('rmAccess.loading', variable(false))
  .path("rmAccess.startRMSession", {
    call: async ({ req }, { get, set, call }) => {

      await set('rmAccess.loading', true);
      const [messages] = await getValues(get('i18n.messages'));
      const [authUserId] = await getValues(get('auth.userId'));

      const userId = authUserId;
      const selectedContractId = req.args[0];

      const guidStr = Guid();
      const inputParam = `${userId}#@#${selectedContractId}`;

      const [result] = await getValues(get(`roster.data.bankerrmaccess.startRMSession["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        if (data.ret === API_RESPONSE_CODES.SUCCESS) {
          await set('auth.lastSessionTZ', data.contractLastSession);
          await set('auth.authHeader', data.jwt);
          call('rmAccess.checkEntitlementVascoStatus');
        }
        if (data.ret === API_RESPONSE_CODES.ERROR_CODE && data.errCode === RM_ACCESS_ERROR_CODE.SESSION_ERROR) {
          await Promise.all([
            set('rmAccess.loading', false),
            set('rmAccess.showErrorModal', true),
            set('rmAccess.errorMsg', messages['app.rmAccess.session.error']),
            set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
          ])
        }
        if (data.ret === API_RESPONSE_CODES.ERROR_CODE && data.errCode === RM_ACCESS_ERROR_CODE.NO_ACCESS) {
          await Promise.all([
            set('rmAccess.loading', false),
            set('rmAccess.showErrorModal', true),
            set('rmAccess.errorMsg', messages['app.rmAccess.bpcontract.noaccess.error']),
            set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
          ])
        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.loading', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError']),
          set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
        ])
      });
    }
  })

  // Pre-Dashboard calls
  .path('rmAccess.checkEntitlementVascoStatus', {
    call: async ({ req }, { get, set, call }) => {

      await call('userprofile.getUserDetails');
      await call('auth.setUserPrefLanguage');

      await call('auth.checkEntitlementUserPf');
      const [messages] = await getValues(get('i18n.messages'));

      const [noEntitlementUserPf] = await getValues(get('auth.noEntitlementUserPf'));

      if (noEntitlementUserPf) {
        await Promise.all([
          set('rmAccess.loading', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.noEntitlements']),
          // set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
        ])
        return;
      }

      let vascoActivated = false;
      if (config.features.vascoAuth) {
        const deviceCode = "BROWSER";
        let [secondFactorStatusResponse] = await getValues(get([`roster.data.vascoauthentication.handleSecondFactorStatus.["${deviceCode}"]`]));

        secondFactorStatusResponse = JSON.parse(secondFactorStatusResponse);

        await set('vascoauthentication.isNTB', secondFactorStatusResponse.ntb);
        await set('vascoauthentication.gracePeriod', secondFactorStatusResponse.gracePeriod);

        // this is for static configuration..
        if (config.defaultEnvironment == 'static') {
          secondFactorStatusResponse.statusDtls[0].vascoStatus = VASCO_STATUSES.complete;
        }

        if (secondFactorStatusResponse) {
          // If at least one device has ACT_COMPLETE status, then can proceed with Vasco 2fa
          const isVascoComplete = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.complete);
          // If at least one device has ACT_PIN_ERROR status, then show Lock User modal
          const isUserLocked = lsome(secondFactorStatusResponse.statusDtls, (statusDtl) => statusDtl.vascoStatus === VASCO_STATUSES.pinError);


          if (isVascoComplete) {
            // await set('auth.vascoFlow', VASCO_FLOW.browser);
            vascoActivated = true;
            await set('auth.vascoActivated', vascoActivated);
          }
          await set('auth.vascoFlow', VASCO_FLOW.browser);
        }
      }
      await call('rmAccess.getDashboardCalls');
    }
  })

  // Dashboard preparation calls
  .path("rmAccess.getDashboardCalls", {
    call: async ({ req }, { get, set, call }) => {

      call('ui.history.push', { pathname: '/loadportfolio' });
      await set('auth.loadportfoliosrc', true);
      await set('auth.dashboardAuthorised', true); // to show app-nav
      await set('rsa.rsaAuthorised', false);
      await set('vascoauthentication.vascoAuthorised', true); // to show portfolio without XXX in dropdown list
      await set('app.user.selectedPortfolioId', null);
      //  dashboard calls start

      const [regionCode] = await getValues(get(['config.regionCode']));
      const [messages] = await getValues(get('i18n.messages'));
      // JIRA WMCE-406
      if (regionCode == 'CH') {
        // await call('auth.entitlementCheck');
        await call('auth.getDashboardSummaryData');
        // const [noEntitlementLt] = await getValues(get('auth.noEntitlement'));
        // if (noEntitlementLt) {
        //   await set('auth.authorised', false);
        //   set('auth.loginBusy', false);
        //   await call('ui.history.replace', { pathname: '/login' });
        //   return;
        // }

      }
      /*
      // DASHBOARD CONTENT RELATED CHECKS START
      const [portfolioId] = await getValues(get('app.user.selectedPortfolioId'))
      if (!portfolioId) {

        const ran_str = "random" + Math.round(Math.random() * 1000);

        const [_portfoliosTop, _portfolioLength, _cache,] = await getValues(get([
          `roster.data.portfolios.top`,
          `roster.data.portfolios.length`,
          //  'roster.data.getInsightRoles',
          `roster.data.cache.${ran_str}`,  // req[0] is ran_str
        ]));

        const [entitlement] = await getValues(get('auth.entitlement'));
        // JIRA WMCE-406
        if (entitlement.insights) {
          const [_insightsRoles] = await getValues(get('roster.data.getInsightRoles'));
          await set('cioinsights.roles', _insightsRoles);
        }

        const topPortfolio = await JSON.parse(_portfoliosTop);

        // await set('cioinsights.roles', _insightsRoles);
        // ALVIN: this is temporary fix, we need to make get currency work inside getValues
        await set('app.user.portfolios.length', _portfolioLength);

        // if (isEmpty(topPortfolio)) {
        //   await set('auth.invalidLogin', true);
        //   await set('auth.errorMsg', messages['app.auth.portfolio.noAccess']);
        //   set('auth.loginBusy', false);
        //   return;
        // }

        const portfolioId = topPortfolio.id;
        const title = topPortfolio.title;
        const referenceCurrency = topPortfolio.referenceCurrency;
        const relId = topPortfolio.relId;
        const branchCode = topPortfolio.branchCode;
        const isPaymentAvailable = topPortfolio.isPaymentAvailable;
        if (portfolioId.$type == 'notFound') {
          await call('ui.history.replace', { pathname: '/noportfolios' });
          return;
        }

        const portfolio = { id: portfolioId, title, referenceCurrency, relId, branchCode, isPaymentAvailable };

        await set('app.user.selectedPortfolioId', portfolioId);
        await set('app.user.selectedPortfolioData', portfolio);
        await set('auth.authorised', true);
        set('ui.state.portfolio.view.selectedId', 'chart');
        set('portfolio.portfolioBarDismissed', false);


        // const [_discoveryHistoryList] = await getValues(get('auth._discoveryHistoryList')); Suraj
        const [_discoveryHistoryList] = await getValues(get([
          'roster.data.discovery.history'
        ]));
        if (_discoveryHistoryList.$type != 'error' || _discoveryHistoryList.$type != 'atom') {
          await set('discovery.history', _discoveryHistoryList);
        } else {
          await set('discovery.history', []);
        }

        // Transition to Portfolio screen is done once we get portfolio data
        const [loadportfoliosrc] = await getValues(get('auth.loadportfoliosrc'));
        if (loadportfoliosrc) {
          call('ui.history.push', { pathname: '' });
          await set('auth.loadportfoliosrc', false);
        }

        const [docsignFeature] = await getValues(get(['config.docsign']));
        if (docsignFeature) {

          const [showDocsignBannerResponse] = await getValues(get('auth.docsignData'));
          if (showDocsignBannerResponse) {
            if (showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docsign.showDocsignBanner', showDocsignBannerResponse.data.showBanner === 'Y');
              await set('docsign.firstTimeSubscription', showDocsignBannerResponse.data.showBanner === 'Y');
            } else if (showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || showDocsignBannerResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
            } else {
              await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
            }
          } else {
            await set('docsign.errorMsg', messages['app.digisign.error.tryagain']);
          }
        }
        await call('auth.checkIsPaymentAvailable');
        // JIRA WMCE-406 notification api-call after 2FA for ch
        if (regionCode === 'CH') {
          if (entitlement.notification) {
            call('notifications.getUserNotifications');
          }
        }

      }
      // DASHBOARD CONTENT RELATED CHECKS END
      */
    }
  })

  // Logout of Login On Behalf RM Session while logout is clicked or switch is clicked
  .path('rmAccess.rmSessionLogout', {
    call: async ({ req }, { get, set }) => {
      const [messages] = await getValues(get('i18n.messages'));
      const [adminUserId] = await getValues(get('auth.userId'));
      const request = {
        userId: adminUserId
      }
      const requestObj = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const inputParam = `${requestObj}`;

      const [result] = await getValues(get(`roster.data.bankerrmaccess.rmSessionLogout["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        if (data.returnCode === API_RESPONSE_CODES.SUCCESS) {
          await Promise.all([
            set('rmAccess.loading', false),
            set('rmAccess.showSpinner', false),
            set('rmAccess.showContractList', false),
            set('rmAccess.errorMsg', null),
            set('rmAccess.errorTitle', null),
            set('rmAccess.contractsData', null),
            set('rmAccess.selectedContract', null),
          ])
        }
        if (data.returnCode === API_RESPONSE_CODES.ERROR_CODE && data.errCode === RM_ACCESS_ERROR_CODE.JWT_GENERATION_ERROR) {
          await Promise.all([
            set('rmAccess.loading', false),
            set('rmAccess.showErrorModal', true),
            set('rmAccess.errorMsg', messages['app.rmAccess.session.error']),
            set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
          ])
        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.loading', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError']),
          set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
        ])
      });
    }
  })

  //  RM logout from DWO application
  .path('rmAccess.logout', {
    call: async ({ req }, { get, set, call }) => {

      const [messages] = await getValues(get('i18n.messages'));
      await set('rmAccess.showLogoutSpinner', true);
      const webfolder = Settings.webfolder;
      const pathValue = webfolder != "" ? "/" + webfolder + '/logout' : "/logout";

      set('auth.authHeaderValue', false);
      const [result] = await getValues(get(`roster.data.bankerrmaccess.rmLogout`));

      isValidJsonString(result).then(async (data) => {
        if (data.returnCode === APIRESPONSECODES.success) {
          window.location.href = pathValue;
          await set('rmAccess.showLogoutSpinner', false);
        } else {
          await set('auth.logoutSuccess', false);
          await set('rmAccess.showLogoutSpinner', false);

        }
      }).catch(async (error) => {
        await Promise.all([
          set('rmAccess.showLogoutSpinner', false),
          set('rmAccess.showErrorModal', true),
          set('rmAccess.errorMsg', messages['app.rmAccess.genericError']),
          set('rmAccess.errorTitle', messages['app.rmAccess.genericErrorTitle'])
        ])
      });
    }
  })

  // Clear previous logged RM user
  .path('rmAccess.invalidatePrevSession', {
    call: async ({ req }, { get, set, call }) => {

      await set('rmAccess.loading', true);
      const [userId] = await getValues(get('auth.userId'));
      const [userAdminGroup] = await getValues(get('rmAccess.userAdminGroup'));

      const channel = CHANNEL_TYPES.BROWSER;
      const guidStr = Guid();
      const inputParam = `${userId}#@#${channel}`;
      const [messages] = await getValues(get('i18n.messages'));

      const [result] = await getValues(get(`${USER_MGMT_PATH}.clearOtherSession["${inputParam}"]["${guidStr}"]`));

      isValidJsonString(result).then(async (data) => {
        if (data) {
          await set('rmAccess.loading', false);
        }
      }).catch(async (error) => {
        // await set('rmAccess.loading', false);
      });
    }
  })

  .path('rmAccess.smartCardLoginFailed', {
    call: async ({ req }, { get, set, call }) => {
      const guidStr = Guid();
      const [userId] = await getValues(get(['auth.userId']));
      const action = RM_LOGIN;
      const inputParam = `${userId || ''}#@#${action}`;
      await getValues(get(`${USER_MGMT_PATH}.smartCardLoginFailed["${inputParam}"]["${guidStr}"]`));
    }
  })

  .path('rmAccess.contractsData', variable(null))
  .path('rmAccess.showContractList', variable(false))
  .path('rmAccess.showSpinner', variable(false))
  .path('rmAccess.showErrorModal', variable(false))
  .path('rmAccess.selectedContract', variable(null))
  .path('rmAccess.errorTitle', variable(null))
  .path('rmAccess.searchErrorMsg', variable(null))
  .path('rmAccess.searchErrorTitle', variable(null))
  .path('rmAccess.RMWarningPrompt', variable(false))
  .path('rmAccess.smartCardUrl', variable(null))
  .path('rmAccess.confirmationPopup', variable(false))
  .path('rmAccess.userAdminGroup', variable(null))
  .path('rmAccess.rmAuthorised', variable(false))
  .path('rmAccess.oracleUserId', variable(null))
  .path('rmAccess.showLogoutSpinner', variable(null))
  .path('rmAccess.adminEmailId', variable(null))
  .path('rmAccess.ipAddress', variable(null))